import { Controller } from "web-ui/controller"
import * as Log from "web-ui/log"

const animationDelayMilliseconds = 500;

// Connects to data-controller="modal-dialog"
export default class extends Controller {
  static events = {
    "close": "closeAndRemove"
  }

  connect() {
    this.debug("Connect")

    this.element.showModal()
  }

  disconnect() {
    this.debug("Disconnect")
  }

  closeAndRemove() {
    this.close()
    setTimeout(() => this.remove(), animationDelayMilliseconds)
  }

  close() {
    this.element.close()
  }

  remove() {
    this.element.remove()
  }

  debug(message, data) {
    Log.debug("Modal Dialog - " + message, data)
  }
}
